import { gameConfig } from '../config/gameConfig.js';

/**
 * Bet/balance/win state for the canvas HUD ({@link GameApp#_buildCanvasControls}).
 * Replaces the legacy detached Pixi HUD data model without visual chrome.
 */
export class GameHudState {
  /**
   * @param {{
   *   onBetSync?: (value: number) => void,
   * }} [opts]
   */
  constructor(opts = {}) {
    this.onBetSync = opts.onBetSync ?? null;
    this.balanceValue = null;
    this.betValue = gameConfig.defaultBet;
    this.linesValue = 1;
    this.winValue = 0;
    /** @type {import('../logic/winEvaluator.js').WinResult['hits']} */
    this._winHits = [];
    /** Preset bet amounts from InitialState (`quickBets`). */
    this.quickBets = [];
  }

  /** No-op — spin enablement is handled by canvas controls in GameApp. */
  setSpinEnabled(_on) {}

  setBalance(v) {
    this.balanceValue = v;
  }

  setBet(v) {
    this.betValue = v;
    this.onBetSync?.(this.betValue);
  }

  /**
   * Updates last-win only when {@link v} &gt; 0 (losing spins keep the previous amount).
   * @param {number} v
   * @param {import('../logic/winEvaluator.js').WinResult['hits'] | null} [hits]
   */
  setWin(v, hits = null) {
    if (v <= 0) return;
    this.winValue = v;
    if (Array.isArray(hits)) this._winHits = hits;
  }

  /** @param {number[]} bets */
  setQuickBets(bets) {
    this.quickBets = Array.isArray(bets) ? [...bets] : [];
  }
}
